export default __webpack_public_path__ + "static/SuisseIntl-UltraLight-fbc32a2c254cdcdc1673137d9a02d53d.woff";